import { isNumber } from 'lodash';
import { TurnoverRow } from 'src/domain';
import { getNextMonthKey } from '../monthKeys';

export const calculateCogs = (salesIv: number | undefined | null, markUp: number | undefined | null) => {
    if (!isNumber(salesIv) || !isNumber(markUp)) return;
    if (markUp <= 0) return 0;

    return salesIv / markUp;
};

export const calculateExpectedWeeklyCogs = (expectedCogsNext2Months: number | undefined | null, weeks = 12) => {
    if (!isNumber(expectedCogsNext2Months)) return 0;
    if (expectedCogsNext2Months <= 0) return 0;

    return (expectedCogsNext2Months / 2 / 52) * weeks;
};

export const calculateDSP = (
    expectedWeeklyCogs: number | undefined | null,
    deliveryProfile: number | undefined | null
) => {
    if (!isNumber(expectedWeeklyCogs) || !isNumber(deliveryProfile)) return;
    if (deliveryProfile <= 0) return 0;

    return expectedWeeklyCogs * deliveryProfile;
};

export const calculateDSPForMonthKey = (
    monthKey: number,
    turnoverDataByMonthKey: Record<number, TurnoverRow>,
    markUpAvgData: Record<string, number>,
    deliveryProfileAvgData: Record<number, number>
) => {
    const nextMonthKey1 = getNextMonthKey(monthKey);
    const nextMonthKey2 = getNextMonthKey(nextMonthKey1);

    const plannedSalesNext1 = turnoverDataByMonthKey[nextMonthKey1]?.plannedSalesIv ?? 0;
    const plannedSalesNext2 = turnoverDataByMonthKey[nextMonthKey2]?.plannedSalesIv ?? 0;

    const expectedCogsNext1 = calculateCogs(plannedSalesNext1, markUpAvgData[nextMonthKey1]) ?? 0;
    const expectedCogsNext2 = calculateCogs(plannedSalesNext2, markUpAvgData[nextMonthKey2]) ?? 0;

    const expectedWeeklyCogsNow = calculateExpectedWeeklyCogs(expectedCogsNext1 + expectedCogsNext2) ?? 0;

    const dsp = calculateDSP(expectedWeeklyCogsNow, deliveryProfileAvgData[monthKey]) ?? 0;

    return dsp;
};
